import './App.css';
import {
  SiGithub,
  SiGitlab,
  SiGitee,
  SiReact,
  SiStackoverflow,
  SiMdnwebdocs,
  SiNpm,
  SiDocker,
  SiKubernetes,
  SiCloudflare,
  SiTypescript,
  SiCsdn,
  SiJuejin,
  SiLeetcode,
  SiZhihu,
  SiBilibili,
  SiAlibabacloud,
  SiHuawei,
  SiBytedance
} from 'react-icons/si';

const platformLinks = [
  {
    name: 'Gitee',
    href: 'https://gitee.com',
    description: '代码托管、协作与项目管理平台',
    color: '#c71d23',
    tag: '代码托管',
    Icon: SiGitee
  },
  {
    name: 'CSDN',
    href: 'https://www.csdn.net',
    description: '技术文章、问答与开发资源社区',
    color: '#fc5531',
    tag: '技术社区',
    Icon: SiCsdn
  },
  {
    name: '稀土掘金',
    href: 'https://juejin.cn',
    description: '前后端与工程化实践内容社区',
    color: '#1e80ff',
    tag: '技术社区',
    Icon: SiJuejin
  },
  {
    name: 'LeetCode CN',
    href: 'https://leetcode.cn',
    description: '算法题库与编程训练平台',
    color: '#ffa116',
    tag: '算法',
    Icon: SiLeetcode
  },
  {
    name: '知乎',
    href: 'https://www.zhihu.com',
    description: '开发与技术相关问答讨论社区',
    color: '#1677ff',
    tag: '技术社区',
    Icon: SiZhihu
  },
  {
    name: '哔哩哔哩 技术',
    href: 'https://www.bilibili.com',
    description: '技术课程、实战讲解与开发视频',
    color: '#00a1d6',
    tag: '学习视频',
    Icon: SiBilibili
  },
  {
    name: '阿里云开发者社区',
    href: 'https://developer.aliyun.com',
    description: '云产品文档、实践与开发者内容',
    color: '#ff6a00',
    tag: '云平台',
    Icon: SiAlibabacloud
  },
  {
    name: '华为开发者联盟',
    href: 'https://developer.huawei.com',
    description: '开发文档、SDK 与平台能力入口',
    color: '#cf0a2c',
    tag: '云平台',
    Icon: SiHuawei
  },
  {
    name: '火山引擎',
    href: 'https://www.volcengine.com',
    description: '云服务、AI 与开发平台入口',
    color: '#2f6bff',
    tag: '云平台',
    Icon: SiBytedance
  },
  {
    name: 'GitHub',
    href: 'https://github.com',
    description: '代码托管、协作与项目管理平台',
    color: '#24292f',
    tag: '代码托管',
    Icon: SiGithub
  },
  {
    name: 'GitLab',
    href: 'https://gitlab.com',
    description: '支持 CI/CD 与 DevSecOps 一体化流程',
    color: '#fc6d26',
    tag: '代码托管',
    Icon: SiGitlab
  },
  {
    name: 'Stack Overflow',
    href: 'https://stackoverflow.com',
    description: '开发者问题检索与技术问答社区',
    color: '#f48024',
    tag: '技术社区',
    Icon: SiStackoverflow
  },
  {
    name: 'MDN Web Docs',
    href: 'https://developer.mozilla.org/zh-CN/',
    description: '前端标准文档与 API 参考',
    color: '#00d9ff',
    tag: '文档',
    Icon: SiMdnwebdocs
  },
  {
    name: 'TypeScript Docs',
    href: 'https://www.typescriptlang.org/docs/',
    description: 'TypeScript 官方文档与手册',
    color: '#3178c6',
    tag: '文档',
    Icon: SiTypescript
  },
  {
    name: 'npm',
    href: 'https://www.npmjs.com',
    description: 'JavaScript 生态包管理与发布平台',
    color: '#cb3837',
    tag: '包管理',
    Icon: SiNpm
  },
  {
    name: 'Docker Hub',
    href: 'https://hub.docker.com',
    description: '容器镜像仓库与分发中心',
    color: '#2496ed',
    tag: '容器',
    Icon: SiDocker
  },
  {
    name: 'Kubernetes Docs',
    href: 'https://kubernetes.io/docs/home/',
    description: 'Kubernetes 官方文档与部署指南',
    color: '#326ce5',
    tag: '容器编排',
    Icon: SiKubernetes
  },
  {
    name: 'Cloudflare Docs',
    href: 'https://developers.cloudflare.com/',
    description: 'CDN、Workers、Edge 平台文档',
    color: '#f38020',
    tag: '云平台',
    Icon: SiCloudflare
  }
];

function App() {
  const currentYear = new Date().getFullYear();
  const policeBeianIcon = `${process.env.PUBLIC_URL}/police-beian-badge.png`;

  return (
    <div className="App">
      <div className="bg-grid" aria-hidden="true" />
      <div className="bg-stars" aria-hidden="true" />
      <div className="bg-aurora aurora-one" aria-hidden="true" />
      <div className="bg-aurora aurora-two" aria-hidden="true" />
      <div className="bg-glow glow-one" aria-hidden="true" />
      <div className="bg-glow glow-two" aria-hidden="true" />
      <main className="App-main">
        <span className="corner-badge">
          <SiReact aria-hidden="true" />
          TECH NAV
        </span>
        <h1 className="site-title">开源代码学习小站</h1>
        <p className="site-subtitle">技术网站导航</p>

        <section className="content-block">
          <h2>网站导航</h2>
          <div className="platform-scroll">
            <div className="platform-grid">
              {platformLinks.map(({ name, href, description, color, tag, Icon }) => (
                <a
                  className="platform-card"
                  href={href}
                  key={name}
                  style={{ '--card-accent': color }}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                >
                  <div className="platform-icon" aria-hidden="true">
                    <Icon />
                  </div>
                  <div className="platform-content">
                    <div className="platform-headline">
                      <h3>{name}</h3>
                      <span className="platform-tag">{tag}</span>
                    </div>
                    <p>{description}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>
      </main>
      <footer className="site-footer">
        <div className="beian-block">
          <div className="beian-row">
            <span className="beian-label">ICP备案号：</span>
            <a
              className="beian-link"
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              苏ICP备2022013651号-3
            </a>
          </div>
          <div className="beian-row beian-row-police">
            <img className="beian-icon" src={policeBeianIcon} alt="" aria-hidden="true" />
            <a
              className="beian-link"
              href="https://beian.mps.gov.cn/#/query/webSearch?code=32011302323139"
              target="_blank"
              rel="noreferrer"
            >
              苏公网安备32011302323139号
            </a>
          </div>
        </div>
        <p className="copyright">© {currentYear} 开源代码学习小站 版权所有</p>
      </footer>
    </div>
  );
}

export default App;
